@if (auth.isAuthenticated()) {
  <mat-sidenav-container class="sidenav-container">
    <mat-sidenav
        #sidenav
        [mode]="isMobile() ? 'over' : 'side'"
        [opened]="!isMobile()"
        class="sidenav">
      <div class="sidenav-header">
        <mat-icon class="logo-icon">sports_soccer</mat-icon>
        <span class="logo-text">BettingSpot</span>
      </div>
      <mat-nav-list>
        <a mat-list-item routerLink="/dashboard" routerLinkActive="active-link" (click)="isMobile() && sidenav.close()">
          <mat-icon matListItemIcon>dashboard</mat-icon>
          <span matListItemTitle>Dashboard</span>
        </a>
        <a mat-list-item routerLink="/events" routerLinkActive="active-link" (click)="isMobile() && sidenav.close()">
          <mat-icon matListItemIcon>event</mat-icon>
          <span matListItemTitle>Eventi</span>
        </a>
        <button mat-list-item type="button" (click)="toggleGroup('betting')" class="settings-toggle">
          <mat-icon matListItemIcon>trending_up</mat-icon>
          <span matListItemTitle>Betting</span>
          <mat-icon matListItemMeta class="expand-icon" [class.expanded]="expandedGroup === 'betting'">expand_more</mat-icon>
        </button>
        @if (expandedGroup === 'betting') {
          <a mat-list-item routerLink="/sure-bets" routerLinkActive="active-link" (click)="isMobile() && sidenav.close()" class="submenu-item">
            <mat-icon matListItemIcon>trending_up</mat-icon>
            <span matListItemTitle>Sure Bet</span>
          </a>
          <a mat-list-item routerLink="/middle-bets" routerLinkActive="active-link" (click)="isMobile() && sidenav.close()" class="submenu-item">
            <mat-icon matListItemIcon>call_split</mat-icon>
            <span matListItemTitle>Middle Bet</span>
          </a>
          <a mat-list-item routerLink="/odd-movements" routerLinkActive="active-link" (click)="isMobile() && sidenav.close()" class="submenu-item">
            <mat-icon matListItemIcon>show_chart</mat-icon>
            <span matListItemTitle>Andamento Quote</span>
          </a>
          <a mat-list-item routerLink="/sistemi" routerLinkActive="active-link" (click)="isMobile() && sidenav.close()" class="submenu-item">
            <mat-icon matListItemIcon>calculate</mat-icon>
            <span matListItemTitle>Sistemi</span>
          </a>
          <a mat-list-item routerLink="/schedine" routerLinkActive="active-link" (click)="isMobile() && sidenav.close()" class="submenu-item">
            <mat-icon matListItemIcon>receipt_long</mat-icon>
            <span matListItemTitle>Schedine</span>
          </a>
          @if (auth.currentUser()?.admin) {
            <a mat-list-item routerLink="/admin/error-correction-suggestions" routerLinkActive="active-link" (click)="isMobile() && sidenav.close()" class="submenu-item">
              <mat-icon matListItemIcon>travel_explore</mat-icon>
              <span matListItemTitle>Suggeritore Sistemi</span>
            </a>
          }
        }
        <button mat-list-item type="button" (click)="toggleGroup('community')" class="settings-toggle">
          <mat-icon matListItemIcon>groups</mat-icon>
          <span matListItemTitle>Community</span>
          <mat-icon matListItemMeta class="expand-icon" [class.expanded]="expandedGroup === 'community'">expand_more</mat-icon>
        </button>
        @if (expandedGroup === 'community') {
          <a mat-list-item routerLink="/feed" routerLinkActive="active-link" (click)="isMobile() && sidenav.close()" class="submenu-item">
            <mat-icon matListItemIcon>dynamic_feed</mat-icon>
            <span matListItemTitle>Feed</span>
          </a>
          <a mat-list-item routerLink="/leaderboard" routerLinkActive="active-link" (click)="isMobile() && sidenav.close()" class="submenu-item">
            <mat-icon matListItemIcon>emoji_events</mat-icon>
            <span matListItemTitle>Classifica</span>
          </a>
        }
        @if (auth.currentUser()?.admin) {
          <button mat-list-item type="button" (click)="toggleGroup('settings')" class="settings-toggle">
            <mat-icon matListItemIcon>settings</mat-icon>
            <span matListItemTitle>Settings</span>
            <mat-icon matListItemMeta class="expand-icon" [class.expanded]="expandedGroup === 'settings'">expand_more</mat-icon>
          </button>
          @if (expandedGroup === 'settings') {
            <a mat-list-item routerLink="/grabbers" routerLinkActive="active-link" (click)="isMobile() && sidenav.close()" class="submenu-item">
              <mat-icon matListItemIcon>cloud_download</mat-icon>
              <span matListItemTitle>Grabber</span>
            </a>
            <a mat-list-item routerLink="/admin/users" routerLinkActive="active-link" (click)="isMobile() && sidenav.close()" class="submenu-item">
              <mat-icon matListItemIcon>manage_accounts</mat-icon>
              <span matListItemTitle>Utenti</span>
            </a>
            <a mat-list-item routerLink="/bookmakers" routerLinkActive="active-link" (click)="isMobile() && sidenav.close()" class="submenu-item">
              <mat-icon matListItemIcon>storefront</mat-icon>
              <span matListItemTitle>Provider</span>
            </a>
            <a mat-list-item routerLink="/admin/events-review" routerLinkActive="active-link" (click)="isMobile() && sidenav.close()" class="submenu-item">
              <mat-icon matListItemIcon>fact_check</mat-icon>
              <span matListItemTitle>Eventi da verificare</span>
            </a>
            <a mat-list-item routerLink="/admin/scheduling" routerLinkActive="active-link" (click)="isMobile() && sidenav.close()" class="submenu-item">
              <mat-icon matListItemIcon>schedule</mat-icon>
              <span matListItemTitle>Pianificazione</span>
            </a>
          }
        }
      </mat-nav-list>
    </mat-sidenav>

    <mat-sidenav-content class="main-content">
      <mat-toolbar color="primary" class="toolbar">
        @if (isMobile()) {
          <button mat-icon-button (click)="sidenav.toggle()" title="Menu">
            <mat-icon>menu</mat-icon>
          </button>
        }
        <span>BettingSpot</span>
        <span class="toolbar-spacer"></span>
        @if (auth.currentUser(); as user) {
          <a class="user-badge" routerLink="/profile/settings" matTooltip="Il mio profilo">
            @if (user.picture) {
              <img class="user-avatar" [src]="user.picture" [alt]="user.name" referrerpolicy="no-referrer" />
            }
            <span class="user-name">{{ user.name }}</span>
          </a>
        }
        <button mat-icon-button (click)="auth.logout()" title="Esci">
          <mat-icon>logout</mat-icon>
        </button>
      </mat-toolbar>
      <div class="content-area">
        <router-outlet />
      </div>
    </mat-sidenav-content>
  </mat-sidenav-container>
} @else {
  <router-outlet />
}
